import { createSlice } from '@reduxjs/toolkit'
import storage from 'util/storage'
import { IN_APP_CARD_CHANGE_OPEN_STATE } from './types'

const STORAGE_KEY = 'inappcards-open'

const stored = storage.get(STORAGE_KEY)
const initialState = stored || {
  'recent-tickets': true,
  'custom-profile': true,
}

const openState = createSlice({
  name: 'inAppCardsOpenState',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(IN_APP_CARD_CHANGE_OPEN_STATE, (draftState, action) => {
      const { key, isOpen } = action.payload
      const newState = {
        ...draftState,
        [key]: isOpen,
      }
      storage.set(STORAGE_KEY, newState)
      return newState
    })
  },
})

export default openState.reducer
